import Vue from 'vue'
// import { subMonths, format } from "date-fns"; // 29.5K
import subMonths from "date-fns/sub_months";
import format from "date-fns/format";
import getDaysInMonth from "date-fns/get_days_in_month";
import setDay from "date-fns/set_day";
import getDay from 'date-fns/get_day';
import addDays from 'date-fns/add_days';
import addMonths from 'date-fns/add_months';

Object.defineProperty(Vue.prototype,'$dateFns', {
  value: {
    format,
    subMonths,
    getDaysInMonth,
    setDay,
    getDay,
    addDays,
    addMonths
  }
});
